import(/* webpackMode: "eager", webpackExports: ["IntentLink"] */ "/vercel/path0/components/layout/site-nav/IntentLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExplainerVideo"] */ "/vercel/path0/components/marketing/ExplainerVideo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BelowFoldBands"] */ "/vercel/path0/components/showcase/BelowFoldBands.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RevealOnView"] */ "/vercel/path0/components/showcase/RevealOnView.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/features/contests/components/ContestDateTime.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/features/courses/components/CourseThumbnailFallback.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/features/home/components/Countdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleFormsImportField"] */ "/vercel/path0/features/home/components/GoogleFormsImportField.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/features/home/components/hero-stage.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["HeroStage"] */ "/vercel/path0/features/home/components/HeroStage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlaygroundSampleCard"] */ "/vercel/path0/features/home/components/PlaygroundSampleCard.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
